var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$tc('label.fornecedor', 1)))]),_c('v-expansion-panel-content',[_c('card-info',{attrs:{"campos":_vm.campos,"objeto":_vm.formatarObjeto()}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }